module.exports = __webpack_public_path__ + "img/Photopea.0606c5e7.png";